import React, { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { Shield, Check, AlertCircle, ArrowLeft } from 'lucide-react';
import { plans } from '../data/pricing';
import '../assets/css/checkout.css';

function Checkout() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        cardNumber: '',
        expiryDate: '',
        cvv: '',
        billingAddress: '',
        billingCity: '',
        billingPostal: '',
        billingCountry: 'france',
        promoCode: ''
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    // Récupérer le plan sélectionné
    const selectedPlanId = searchParams.get('plan');
    const selectedPlan = plans.find(p => p.id === selectedPlanId);
    const plan = selectedPlan || plans[1]; // Default Premium



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Formater numéro carte
        if (name === 'cardNumber') {
            const cleaned = value.replace(/\D/g, '');
            const formatted = cleaned.replace(/(\d{4})(?=\d)/g, '$1 ');
            setFormData(prev => ({ ...prev, [name]: formatted.slice(0, 19) }));
        }
        // Formater date expiration
        else if (name === 'expiryDate') {
            const cleaned = value.replace(/\D/g, '');
            if (cleaned.length >= 2) {
                const formatted = cleaned.slice(0, 2) + '/' + cleaned.slice(2, 4);
                setFormData(prev => ({ ...prev, [name]: formatted }));
            } else {
                setFormData(prev => ({ ...prev, [name]: cleaned }));
            }
        }
        // Limiter CVV à 3-4 chiffres
        else if (name === 'cvv') {
            setFormData(prev => ({ ...prev, [name]: value.replace(/\D/g, '').slice(0, 4) }));
        }
        else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const validateForm = () => {
        if (!formData.firstName.trim()) {
            setError('Le prénom est requis');
            return false;
        }
        if (!formData.lastName.trim()) {
            setError('Le nom est requis');
            return false;
        }
        if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setError('Email invalide');
            return false;
        }
        if (formData.cardNumber.replace(/\s/g, '').length !== 16) {
            setError('Numéro de carte invalide (16 chiffres)');
            return false;
        }
        if (!formData.expiryDate.match(/^\d{2}\/\d{2}$/)) {
            setError('Date expiration invalide (MM/YY)');
            return false;
        }
        if (formData.cvv.length < 3) {
            setError('CVV invalide (3-4 chiffres)');
            return false;
        }
        if (!formData.billingAddress.trim()) {
            setError('L\'adresse est requise');
            return false;
        }
        if (!formData.billingCity.trim()) {
            setError('La ville est requise');
            return false;
        }
        if (!formData.billingPostal.trim()) {
            setError('Le code postal est requis');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!validateForm()) {
            return;
        }


        // Simuler appel API
        setTimeout(() => {
            console.log('Paiement traité:', formData);
            setSuccess(true);

            // Rediriger après 3 secondes
            setTimeout(() => {
                navigate('/confirmation');
            }, 3000);
        }, 2000);
    };

    // Affichage succès
    if (success) {
        return (
            <div className="checkout-page">
                <div className="container">
                    <div className="checkout-success">
                        <div className="success-icon">
                            <Check size={80} />
                        </div>
                        <h1>Paiement Approuvé!</h1>
                        <p>Votre abonnement SERVICE IPTV est maintenant actif.</p>
                        <p className="order-number">Numéro de commande: #ORD-{Date.now()}</p>
                        <p className="success-message">
                            Vérifiez votre email pour les instructions d'installation.
                        </p>
                        <Link to="/contact" className="btn btn-primary-gradient">
                            Contacter le Support
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="checkout-page">
            <div className="container">
                <Link to="/pricing" className="back-link">
                    <ArrowLeft size={20} />
                    Retour aux tarifs
                </Link>

                <div className="checkout-content">
                    {/* Formulaire */}
                    <div className="checkout-form-section">
                        <h1 className="checkout-title">Finaliser Votre Commande</h1>
                      

                           
                        {error && (
                            <div className="alert alert-error">
                                <AlertCircle size={20} />
                                <p>{error}</p>
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="checkout-form">
                            {/* Informations Personnelles */}
                            <div className="form-section">
                                <h2>Informations Personnelles</h2>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Prénom *</label>
                                        <input
                                            type="text"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            placeholder="Mohammed"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Nom *</label>
                                        <input
                                            type="text"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            placeholder="Alami"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="votre@email.com"
                                        required
                                    />
                                </div>
                            </div>

                           
                        </form>



                    </div>

                    {/* Résumé Commande */}
                    <div className="checkout-summary">
                        <div className="summary-card">
                            <h2>Résumé de Commande</h2>

                            <div className="plan-summary">
                                <div className="plan-header">
                                    <h3>{plan.name}</h3>
                                    <p className="plan-period">Plan Mensuel</p>
                                </div>

                                <ul className="plan-features">
                                    {plan.features.slice(0, 5).map((feature, idx) => (
                                        <li key={idx}>
                                            <Check size={16} />
                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                    {plan.features.length > 5 && (
                                        <li>
                                            <Check size={16} />
                                            <span>+{plan.features.length - 5} autres features</span>
                                        </li>
                                    )}
                                </ul>
                            </div>

                            <div className="summary-details">

                                <div className="summary-note">
                                    💳 Vous serez facturé chaque mois
                                </div>
                            </div>

                            {/* Avantages */}
                            <div className="summary-benefits">
                                <h3>Inclus dans votre abonnement</h3>
                                <ul>
                                    <li>
                                        <Check size={16} />
                                        <span>Essai gratuit 7 jours</span>
                                    </li>
                                    <li>
                                        <Check size={16} />
                                        <span>Support 24/7 en français</span>
                                    </li>
                                    <li>
                                        <Check size={16} />
                                        <span>Annulation sans engagement</span>
                                    </li>
                                    <li>
                                        <Check size={16} />
                                        <span>Paiement sécurisé</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Sécurité */}
                            <div className="summary-security">
                                <Shield size={20} />
                                <div>
                                    <p className="security-title">Paiement Sécurisé</p>
                                    <p className="security-text">Vos données sont chiffrées et protégées</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Checkout;